import React from 'react';
import {Modal} from "rsuite";


const VideoPlayerDialogComponent = (props) => {
    const modalSize = window.innerHeight > 627 ? 'lg' : 'md';

    return (
        <div>
            <Modal size={modalSize} show={props.openDialog} onHide={props.handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>{props.video?.title[props.language]}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{overflow: 'hidden', maxHeight: '100%'}}>
                    <div style={{
                        aspectRatio: '16/9',
                        maxWidth: '100%',
                        height: '100%',
                        textAlign: 'center',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        position: 'relative',
                    }}>
                        { props.video &&
                            <iframe
                                allowFullScreen
                                allow='autoplay'
                                title={props.video.title[props.language]}
                                src={props.video.url[props.language] + `?cc_lang_pref=${props.language}&cc_load_policy=1&hl=${props.language}&persist_hl=1`}
                                style={{
                                    border: 'none',
                                    position: 'absolute',
                                    top: 0,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    height: "100%",
                                    width: '100%',
                                }}
                            />
                        }
                        {/* {loading ? null : ''} */}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default VideoPlayerDialogComponent;